var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItMoreActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S7.1,10,6,10z M6,13c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S6.6,13,6,13z M12,10 c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,10,12,10z M12,13c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1c0.1,0.5-0.3,0.9-0.8,1 C12.1,13,12.1,13,12,13z M18,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S19.1,10,18,10z M18,13c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1 c0.1,0.5-0.3,0.9-0.8,1C18.1,13,18.1,13,18,13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItMoreActions);
export default __webpack_public_path__ + "static/media/it-more-actions.1d1c72cc.svg";
export { ForwardRef as ReactComponent };